import { Fragment, useMemo } from 'react'
import { Link, Typography } from '@mui/material'
import { linkify } from '@/utils/linkify'

/**
 * Текст сообщения чата: адреса http(s):// и www. — кликабельными ссылками в
 * новой вкладке, остальное — текстом (разбор — utils/linkify, без HTML).
 * Цвет ссылки берётся от пузыря: primary на своём (закрашенном primary)
 * сообщении был бы не виден, поэтому ссылку отличает подчёркивание.
 */
export function MessageText({ text }: { text: string }) {
  const parts = useMemo(() => linkify(text), [text])

  return (
    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {parts.map((part, index) =>
        part.type === 'link' ? (
          <Link
            key={index}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            color="inherit"
            underline="always"
            sx={{ overflowWrap: 'anywhere' }}
          >
            {part.text}
          </Link>
        ) : (
          <Fragment key={index}>{part.text}</Fragment>
        ),
      )}
    </Typography>
  )
}
